// src/pages/Auth/ResetPassword.jsx
// -----------------------------------------------------------------------------
// Reset password screen (Additional Requirement: POST /api/Auth/reset-password).
// Directly resets password using Email and the New Password.
// -----------------------------------------------------------------------------
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import authService from '../../api/authService';
import afixLogo from '../../assets/images/afix-logo.png';
import './auth.css';

export default function ResetPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !newPassword) {
      setError('All fields are required.');
      return;
    }

    setSubmitting(true);
    try {
      await authService.resetPassword(email, newPassword);
      toast.success('Password reset completed successfully, please login.');
      navigate('/login');
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Password reset failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      {/* ---------- Left: brand panel ---------- */}
      <div className="auth-brand-panel">
        <div className="auth-blob auth-blob-1" />
        <div className="auth-blob auth-blob-2" />

        <div className="auth-brand-content">
          <img src={afixLogo} alt="AFix logo" className="auth-brand-logo" />
          <h1>Afix</h1>
          <p className="auth-tagline">Track &middot; Fix &middot; Deliver</p>
          <p className="auth-sub">
            Directly reset your account password and restore your workflow.
          </p>
        </div>
      </div>

      {/* ---------- Right: form panel ---------- */}
      <div className="auth-form-panel">
        <div className="auth-form-box">
          <img src={afixLogo} alt="AFix" className="auth-form-logo" />
          <h2>Reset Password</h2>
          <p className="subtitle">Enter details below to directly reset your password</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                id="newPassword"
                type="password"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={submitting}>
              {submitting ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>

          <div className="form-links" style={{ marginTop: '20px', textAlign: 'center' }}>
            <Link to="/login">Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
